import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Download, Briefcase } from 'lucide-react';
import '../styles/Hero.css';

const Hero = ({ data }) => {

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToProjects = () => {
    document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-greeting">Hello, I'm</div>
          <h1 className="hero-name">{data.name}</h1>
          <h2 className="hero-title">{data.title}</h2>
          {data.location && <p className="hero-location">📍 {data.location}</p>}
          <p className="hero-tagline">{data.tagline}</p>
          <p className="hero-bio">{data.bio}</p>
          
          <div className="hero-actions">
            <Button onClick={scrollToContact} size="lg" className="primary-button">
              <Briefcase className="h-5 w-5" />
              Hire Me
            </Button>
            <Button onClick={scrollToProjects} size="lg" variant="outline" className="secondary-button">
              View My Work
              <ArrowRight className="h-5 w-5" />
            </Button>
            <Button asChild size="lg" variant="outline" className="tertiary-button">
              <a
                href="/assets/Berkant_Bicakci_CV.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Download className="h-5 w-5" />
                Download CV
              </a>
            </Button>
          </div>
        </div>

        <div className="hero-visual">
          <div className="floating-card card-1">
            <div className="card-icon-wrapper">
              <svg className="card-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10" strokeWidth={2} />
                <circle cx="12" cy="12" r="3" strokeWidth={2} />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2v4m0 12v4M2 12h4m12 0h4" />
              </svg>
            </div>
            <div className="card-text">Machine Learning</div>
            <div className="card-stat">PyTorch</div>
          </div>
          <div className="floating-card card-2">
            <div className="card-icon-wrapper">
              <svg className="card-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div className="card-text">LLM Systems</div>
            <div className="card-stat">83% Precision</div>
          </div>
          <div className="floating-card card-3">
            <div className="card-icon-wrapper">
              <svg className="card-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <div className="card-text">Deep Learning</div>
            <div className="card-stat">Computer Vision</div>
          </div>
        </div>
      </div>
      
      <div className="hero-gradient-overlay"></div>
    </section>
  );
};

export default Hero;
